module.exports = __webpack_public_path__ + "img/logo_sindonews.60dfa325.png";